/**
 * Plane visual tone — maps to existing semantic CSS tokens only.
 * No new invented brand palette.
 */

import type { UxPathPlaneV1 } from '../contracts/FourPlaneUxA11yContractV1';

export type PlaneVisualToneV1 = {
  plane: UxPathPlaneV1;
  /** Existing CSS custom property — see src/styles/tokens/semantic.css */
  accentToken: string;
  label: string;
};

export const PLANE_VISUAL_TONES_V1: readonly PlaneVisualToneV1[] = [
  { plane: 'public', accentToken: 'var(--color-blue)', label: 'Public' },
  { plane: 'relationship', accentToken: 'var(--color-violet)', label: 'Relationship' },
  { plane: 'business', accentToken: 'var(--color-aqua)', label: 'Business' },
  { plane: 'platform', accentToken: 'var(--color-green)', label: 'Platform' },
] as const;

export function planeAccentTokenV1(plane: UxPathPlaneV1): string {
  const hit = PLANE_VISUAL_TONES_V1.find((t) => t.plane === plane);
  return hit?.accentToken ?? 'var(--color-aqua)';
}

export function planeLabelV1(plane: UxPathPlaneV1): string {
  const hit = PLANE_VISUAL_TONES_V1.find((t) => t.plane === plane);
  return hit?.label ?? plane;
}

/** Assert tones only use var(--*) tokens — no hex invention in this Primary. */
export function assertPlaneTonesUseCssVariablesV1(): boolean {
  return PLANE_VISUAL_TONES_V1.every((t) => t.accentToken.startsWith('var(--'));
}
